import { useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import Box from "../../components/Box";
import MainLayout from "../../components/layouts/MainLayout";
import Pagination from "../../components/Pagination";
import { useCampaigns } from "../../utils/campaign/CampaignUtils";

export default function CampaignPage() {
  const [filter, setFilter] = useState({
    page: 1,
    page_size: 10,
  });

  const { campaigns, meta, loading, errorMsg } = useCampaigns({ filter });

  const gotoPage = (page) => {
    setFilter({ ...filter, page: page });
  };

  return (
    <MainLayout resource_key="campaign">
      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col">
            <h1 className="h3 mb-0 text-gray-800">Daftar Campaign</h1>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <Box title="Campaign List" loading={loading}>
              {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}
              <table className="table table-bordered table-striped table-hover">
                <thead>
                  <tr>
                    <th></th>
                    <th>Nama</th>
                    <th>Slug</th>
                    <th>Tambahan Masa Aktif (hari)</th>
                    <th>Waktu Mulai</th>
                    <th>Waktu Akhir</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {campaigns.length === 0 && (
                    <tr>
                      <td colSpan={7} className="text-center">
                        Tidak ada data
                      </td>
                    </tr>
                  )}
                  {campaigns.map((campaign) => (
                    <tr key={campaign.id}>
                      <td>
                        <Link to={`/campaign/${campaign.id}`} className="btn btn-primary btn-sm">
                          <i className="fa fa-eye"></i> Detail
                        </Link>
                      </td>
                      <td>{campaign.name}</td>
                      <td>{campaign.slug}</td>
                      <td>{campaign.extra_days}</td>
                      <td>{moment(campaign.start_date).format("D MMMM YYYY")}</td>
                      <td>{moment(campaign.end_date).format("D MMMM YYYY")}</td>
                      <td>
                        {campaign.is_active ? (
                          <span className="badge badge-success">Active</span>
                        ) : (
                          <span className="badge badge-secondary">Inactive</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {meta.count > meta.page_size && (
                <Pagination
                  totalpage={Math.ceil(meta.count / meta.page_size)}
                  selectedpage={meta.page}
                  clickpage={(page) => gotoPage(page)}
                  next={() => gotoPage(meta.page + 1)}
                  prev={() => gotoPage(meta.page - 1)}
                />
              )}
            </Box>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
